<template>
	<div class="col-md-12 col-lg-6 col-xl-6 mb-2">
		{{anios}}
		{{anioActual}}
		<b-overlay :show="isOverlay" rounded="sm" spinner-variant="primary" class="h-100">
			<div class="row">
				<div class="col-12">
					<div class="card card-grafica h-100">
						<div class="card-body">
							<div class="filtro-grafic" id="grafica_003" v-if="isVisible">
								<div class="row justify-content-start">
									<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            		                    <form class="form-inline">
            		                        <label class="title-grafic side-l mr-3">Propuestas Realizadas vs Ganadas</label>
											<label for="">Año</label>
											<select @change="GetDashboard" v-model="Anio" class="ml-2 form-control" id="">
												<option value="">Todos</option>
												<option v-for="(item,index) in pListaAnios" :key="index" :value="item">{{item}}</option>
											</select>
											<label class="ml-2" for="">Mes</label>
											<select @change="GetDashboard" v-model="Mes" class="ml-2 form-control" id="">
												<option value="">Todos</option>
												<option value="1">Enero</option>
												<option value="2">Febrero</option>
												<option value="3">Marzo</option>
												<option value="4">Abril</option>
												<option value="5">Mayo</option>
												<option value="6">Junio</option>
												<option value="7">Julio</option>
												<option value="8">Agosto</option>
												<option value="9">Septiembre</option>
												<option value="10">Octubre</option>
												<option value="11">Noviembre</option>
												<option value="12">Diciembre</option>
												<!-- <option v-for="(item,index) in pListaAnios" :key="index" :value="item">{{item}}</option> -->
											</select>
            		                        <!-- <v-date-picker
												mode='range'
												v-model='rangeDate'
												@input="GetListaTrabajadores"
												:input-props='{
													class: "form-control form-control mb-2 mr-1 calendar",
													placeholder: "Selecciona un rango de fecha para buscar",
													readonly: true
												}'
												/>
            		                        <treeselect
            		                            class="d-inline-block w-25 mt-0 pt-0 ml-2"
            		                            style="top: -4px;"
            		                            :maxHeight="180"
            		                            :options="ListaComboTrabajadores"
            		                            placeholder="Trabajador..."
            		                            v-model="IdTrabajador"
            		                            @input="GetListaTrabajadores()"
												:disable-fuzzy-matching="true"
												@search-change="BusquedaTrabajador"
            		                        /> -->
            		                    </form>
            		                    <button type="button" class="btn close abs_01" @click="ocultarfiltro()"><i class="fal fa-times"></i></button>
            		                </div>
								</div>
							</div>
							<div class="row">
								<div class="col-10 col-sm-10 col-md-8 col-lg-8">
									<h6 class="title-grafic side-l">Propuestas Realizadas vs Ganadas</h6>
								</div>
								<div class="col-2 col-sm-2 col-md-4 col-lg-4 text-right">
									<button	type="button" class="btn-fil-002" title="Filtros" @click="mostrarfiltro()">
										<i class="fas fa-filter"></i>
									</button>
								</div>
		
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<hr />
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4" v-if="ShowPieCantidad">
									<div id="apx-03">
										<apexchart height="284" :options="optionscantidad" :series="seriescantidad"></apexchart>
									</div>
									<h3 class="text-center">Cantidad</h3>
								</div>
								<div class="col-lg-4" v-if="ShowPiePorcentaje">
									<div id="apx-03">
										<apexchart height="284" :options="optionsporcentaje" :series="seriesporcentaje"></apexchart>
									</div>
									<h3 class="text-center">Porcentaje</h3>
								</div>
								<div class="col-lg-4" v-if="ShowPieMonto">
									<div id="apx-03">
										<apexchart height="284" :options="optionsmonto" :series="seriesmonto"></apexchart>
									</div>
									<h3 class="text-center">Monto</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</b-overlay>
	</div>
</template>

<script>
export default {
	name:'Cotizacion',
	props:['pListaAnios','pAnioActual'],
	data() {
		return {
			isOverlay: true,
			isVisible:false,
			ShowPieCantidad:false,
			ShowPieMonto:false,
			ShowPiePorcentaje:false,
            masks: {
				input: "DD/MM/YYYY"
			},
			optionscantidad:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels: {
					enabled: true,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						},
					},
					textAnchor:'start'
				},
				plotOptions: {
              		pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
            	},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': '+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Cotizado','Vendido'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			seriescantidad:[50,50],
			optionsporcentaje:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels: {
					enabled: true,
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						}
					}
				},
				plotOptions: {
              		pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
            	},
				tooltip:{
					y:{
						formatter: (value,opts)=> {
							let Total=0;
							opts.config.series.forEach((val) => {Total+=val})
							// console.log(opts.config.series);
							let percentage=(value/Total)*100
              				return percentage.toFixed(1) + '%'
          				},
					},
					style:{
						fontSize:'14px'
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						let Total=0;
						w.config.series.forEach((val) => {Total+=val})
						// console.log(opts.config.series);
						let percentage=(series[seriesIndex]/Total)*100;
              				// return percentage.toFixed(1) + '%'
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': '+percentage.toFixed(1)+'%'
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
				},
				labels:['Cotizado','Vendido'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			seriesporcentaje:[0,0],
			optionsmonto:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels: {
					enabled: true,
					formatter(val, opts) {
                		let fixed = 0;
			let e=0;
			if (opts.w.config.series[opts.seriesIndex] === null) {
				return null;
			} // terminate early
			if (opts.w.config.series[opts.seriesIndex] === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
						: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return '$'+e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						}
					}
				},
				plotOptions: {
              		pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
            	},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return '$'+e;
						}
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	let Total=0;
						let val=parseFloat(series[seriesIndex]);
						let fixed = 0;
						let e=0;
						if (val === null) {
							return null;
						} // terminate early
						if (val === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = val.toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? val.toFixed(0 + fixed)
									: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						// Total='$'+e;
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': $'+e
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
					fixed:{
						enabled:true,
						position:'bottomLeft',
						offsetY:60
					}
				},
				labels:['Cotizado','Vendido'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			seriesmonto:[50,50],
			Anio:new Date().getFullYear(),
			Mes:''
		}
	},
	methods: {
		mostrarfiltro(){
            this.isVisible=true;
        },
        ocultarfiltro(){
            this.isVisible=false;
        },
		async GetDashboard(){
			this.ShowPieCantidad=false;
			this.ShowPiePorcentaje=false;
			this.ShowPieMonto=false;
            this.isOverlay=true;
			return new Promise((resolve,reject)=>{
				this.$http.get('cotizacioncobranza',{
                params:{
					Anio:this.Anio,
					Mes:this.Mes
                }
            }).then((res)=>{
                this.seriescantidad[0]=parseInt(res.data.data.Cantidad[0]);
				this.seriescantidad[1]=parseInt(res.data.data.Cantidad[1]);
				this.seriesmonto[0]=parseInt(res.data.data.Monto[0]);
				this.seriesmonto[1]=parseInt(res.data.data.Monto[1]);
				this.seriesporcentaje[0]=parseInt(res.data.data.Cantidad[0]);
				this.seriesporcentaje[1]=parseInt(res.data.data.Cantidad[1]);
				resolve(res.data);
				// console.log(this.seriescantidad);
            	}).finally(()=>{
					this.ShowPieCantidad=true;
					this.ShowPieMonto=true;
					this.ShowPiePorcentaje=true;
            	    this.isOverlay=false;
            	})
			})
        },
	},
	created() {
		if(this.pListaAnios !== undefined){
			this.ListaAnios = this.pListaAnios;
		}

		if(this.pAnioActual !== undefined) {
			this.Anio = this.pAnioActual
		}

		this.bus.$off("Ocultar7");
		this.bus.$on("Ocultar7", data => {
			this.Ocultar(data);
		});
	},
    computed: {
		anios(){
			if(this.pListaAnios !== undefined){
				this.ListaAnios = this.pListaAnios;
			}
		},

		anioActual(){
			if(this.pAnioActual !== undefined) {
				this.Anio = this.pAnioActual

			}
		}
	},
	mounted() {
        // this.GetDashboard();
    },
}
</script>

<style>

</style>
